import msgs from '../../../main/resources/messages/messages.properties';

export const getMessage = (key, ...args) => {
    const msg = msgs[key];
    if (!msg) {
        return key;
    }
    return args.reduce(
        (s, a, i) => s.replace(new RegExp(`\\{${i}\\}`, 'g'), a),
        msg
    );
};

export const addMessage = msgObj => {
    Object.entries(msgObj).forEach(([k, v]) => (msgs[k] = v));
};

export const getAllMessages = () => msgs;

export const messagePlugin = {
    install(Vue) {
        Vue.prototype.$t = getMessage;
    }
};

function getSlots(s, cb = x => x) {
    const m = /\{\d+\}/.exec(s);
    if (m) {
        const rest = s.substring(m.index + m[0].length);
        const index = parseInt(m[0].substring(1, m[0].length - 1), 10);
        return [
            s.substring(0, m.index),
            cb(index, m[0]),
            ...(rest ? getSlots(rest, cb) : [])
        ];
    }
    return [s];
}

export const message = {
    name: 'message',
    props: ['msgKey'],
    render(h) {
        const msg = getMessage(this.msgKey);
        const arr = getSlots(msg, i => {
            const s = this.$scopedSlots['arg' + i];
            return s ? s() : '';
        });
        return h('span', arr);
    }
};
